export const DATE_RANGE_FIELD_PRESENTATIONS = ['dropdown', 'modal'] as const;
export type DateRangeFieldPresentation =
  (typeof DATE_RANGE_FIELD_PRESENTATIONS)[number];

export const DATE_RANGE_FIELD_SIZES = ['md', 'lg'] as const;
export type DateRangeFieldSize = (typeof DATE_RANGE_FIELD_SIZES)[number];
